module.exports = __webpack_public_path__ + "assets/img/cup.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/cup.svg
// module id = 704
// module chunks = 0